/**
 * UNUSED
 */

!((document, Drupal, $) => {
  'use strict';

  /**
   * Use this to describe what your behavior does.
   */
  Drupal.behaviors.header = {
    attach: function (context) {

      let header = $('.header__container', context);
      let desktopBackground = header.data('header-bg');
      let mobileBackground = header.data('mobile-header-bg');


      function isBgDefined(el) {
        let bg = $(el).css('background-image');
        if (bg !== 'none') {
          let regex = /(url\(["|'])(.*?)(["|']\))/gm;
          let match = regex.exec(bg);
          if (match) {
            return match[2];
          }
        }
        return false;
      }

      function toggleHeaderBackground() {
        let bgDefined = isBgDefined(header);
        if (window.innerWidth < 860 && mobileBackground) {
          if (!bgDefined || bgDefined !== mobileBackground) {
            header.css({
              'background-image': 'url(' + mobileBackground + ')',
              'background-position-x': 'left'
            });
          }
        }
        else {
          if (!bgDefined || bgDefined !== desktopBackground) {
            header.css({
              'background-image': 'url(' + desktopBackground + ')',
              'background-position-x': 'right'
            });
          }
        }
      }

      toggleHeaderBackground();

      (function () {
        var throttle = function (type, name, obj) {
          obj = obj || window;
          var running = false;
          var func = function () {
            if (running) {
              return;
            }
            running = true;
            requestAnimationFrame(function () {
              obj.dispatchEvent(new CustomEvent(name));
              running = false;
            });
          };
          obj.addEventListener(type, func);
        };

        /* init - you can init any event */
        throttle('resize', 'optimizedResize');
      })();

      window.addEventListener('optimizedResize', function () {
        toggleHeaderBackground();
      });

    }
  };
})(document, Drupal, jQuery);
